import { useCallback, useState, useEffect } from "react";
import { IoCheckmarkCircle, IoCloseCircle } from "react-icons/io5";
import Table from "../../../components/common/Table";
import Pagination from "../../../components/common/Pagination";
import Toaster from "../../../components/common/Toaster";
import referralService from "../../../services/referralService";
import moment from "moment";

const ReferralsTable = ({ columns, tableOptions, onChange }) => {
  const [referrals, setReferrals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchReferrals = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await referralService.getReferralsASync(tableOptions);
        const { result, page, total_count } = response;

        const data = result.map((item) => {
          const referral = (
            <div className="flex items-center">
              {item.is_valid_referral && item.is_validated && (
                <IoCheckmarkCircle className="text-green-500 mr-2" />
              )}
              {!item.is_valid_referral && item.is_validated && (
                <IoCloseCircle className="text-red-400 mr-2" />
              )}
              <div className="text-gray-500">{item.referral_code}</div>
            </div>
          );

          item["referral_code"] = referral;
          item["referrer_name"] = item.referrer_name ?? "-";
          item["created_on"] = moment(item.created_on).format("LL");

          return item;
        });

        if (mounted) {
          setReferrals(data);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [tableOptions]
  );

  useEffect(() => {
    let mounted = true;

    fetchReferrals(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchReferrals]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={referrals}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default ReferralsTable;
